import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";

export function useConfirm() {
  const [state, setState] = useState(null);
  const resolverRef = useRef(null);

  const confirm = (message, opts = {}) => {
    return new Promise(resolve => {
      resolverRef.current = resolve;
      setState({ message, ...opts });
    });
  };

  const close = (result) => {
    resolverRef.current?.(result);
    resolverRef.current = null;
    setState(null);
  };

  const ConfirmDialogElement = () => {
    if (!state) return null;
    return (
      <div
        className="fixed inset-0 bg-black/50 z-[300] flex items-center justify-center p-4"
        onMouseDown={e => e.target === e.currentTarget && close(false)}
      >
        <div className={`bg-white rounded-2xl shadow-2xl ${state.altLabel ? "w-[460px]" : "w-[380px]"} max-w-[95vw] overflow-hidden`}>
          <div className="px-5 py-4">
            {state.title && <div className="text-base font-bold text-slate-900 mb-1.5">{state.title}</div>}
            <div className="text-sm text-slate-600">{state.message}</div>
          </div>
          <div className="flex flex-wrap justify-end gap-2 px-5 py-3 border-t border-slate-100">
            <Button variant="ghost" onClick={() => close(false)}>{state.cancelLabel || "Отмена"}</Button>
            {state.altLabel && (
              <Button variant={state.altDanger ? "destructive" : "outline"} onClick={() => close("alt")}>{state.altLabel}</Button>
            )}
            <Button variant={state.danger ? "destructive" : "default"} onClick={() => close(true)}>
              {state.confirmLabel || "Удалить"}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return { confirm, ConfirmDialogElement };
}
